<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <div class="within_box">
        <div class="title_box">
          <p class="line"></p>
          <p class="title">Case Detail</p>
        </div>
        <div class="form_box">
          <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="SR编号" prop="srNumber">
                  <el-input v-model="detailForm.srNumber" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="回收启动日期" prop="recoveryStartDate">
                  <el-date-picker v-model="detailForm.recoveryStartDate" disabled type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回收项目简介" prop="recoveryProjectSummary">
                  <el-input v-model="detailForm.recoveryProjectSummary" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="已结案" prop="isClosed">
                  <el-select v-model="detailForm.isClosed" disabled placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in isClosedLists" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="SR等级" prop="srGrade">
                  <el-select v-model="detailForm.srGrade" disabled placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in srGradeLists" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发起人" prop="createBy">
                  <el-input v-model="detailForm.createBy" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="status">
                  <ic-select disabled table="TT_QSPI_STOCK_REC_HEADER" field="STATUS" v-model="detailForm.status" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="原因" prop="reason">
                  <el-input v-model="detailForm.reason" disabled type="textarea" maxlength="100" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="remarks">
                  <el-input v-model="detailForm.remarks" disabled type="textarea" maxlength="100" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="tab_box">
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="产品明细" name="tab1">
            <ux-grid ref="plxTable1" :data="tableData1" keep-source max-height="500" show-overflow="tooltip" highlight-current-row>
              <ux-table-column align="center" title="序号" type="index" width="60" />
              <ux-table-column align="center" title="产品编号" field="eightBitCode" min-width="100"></ux-table-column>
              <ux-table-column align="center" title="产品名称" field="eightBitCodeName" min-width="100"></ux-table-column>
              <ux-table-column align="center" title="结算单位名称" field="supplierName" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="Facility名称" field="facilityName" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="产品批次" field="batchNo" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="涉及DCs" field="relatedDcName" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="Regions" field="regoins" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="回收范围" field="recoveryScopeI18n" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="餐厅回收数量(箱)" field="restaurantRecoveryQty" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="DC回收数量(箱)" field="dcRecoveryQty" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="回收数量(箱)" field="recoveryQty" min-width="120"></ux-table-column>
              <ux-table-column align="center" title="处理结果" field="handlingResultI18n" min-width="120"></ux-table-column>
            </ux-grid>
          </el-tab-pane>
          <el-tab-pane label="附件上传" name="tab2">
            <el-table ref="plxTable2" :data="tableData2" max-height="500" border highlight-current-row>
              <el-table-column align="center" label="附件大类" prop="attachmentLargeCategory" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="附件子类" prop="attachmentSmallCategory" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="附件名称" prop="fileName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" @click="onDownload(scope.row,scope.$index)">{{scope.row.fileName}}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="上传人" prop="uploadBy" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传时间" prop="uploadTime" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="tab3">
            <el-table ref="plxTable3" :data="tableData3" max-height="500" highlight-current-row>
              <el-table-column align="center" label="操作时间" prop="operateTime"></el-table-column>
              <el-table-column align="center" label="操作人" prop="operateBy"></el-table-column>
              <el-table-column align="center" label="操作描述" prop="operateDesc"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import StockRecoveryApi from "@/api/StockRecovery/index";
import commonConstants from "@/constants/commonConstants";
import { fileService } from "@/api/common/file-utils";
export default {
  components: {
    IcSelect,
  },
  data() {
    return {
      activeName: "tab1",
      ttQspiStockRecHeaderId: this.$route.query.ttQspiStockRecHeaderId,
      detailForm: {
        srNumber: "",
        recoveryStartDate: "",
        recoveryProjectSummary: "",
        isClosed: "N",
        srGrade: "A",
        createBy: "",
        status: "Processing",
        reason: "",
        remarks: "",
      },
      tableData1: [],
      tableData2: [],
      tableData3: [],
      isClosedLists: [
        {
          label: "Y",
          value: "Y",
        },
        {
          label: "N",
          value: "N",
        }
      ],
      srGradeLists: [
        {
          label: "A",
          value: "A",
        },
        {
          label: "B",
          value: "B",
        },
        {
          label: "C",
          value: "C",
        },
        {
          label: "D",
          value: "D",
        }
      ],
    }
  },
  watch: {

  },
  mounted() {
    this.getHeaderInfo()
    this.getTableInfo()
    this.getAttachmentsLists()
    this.getOperateLogs()
  },
  methods: {
    getHeaderInfo() {
      StockRecoveryApi.getHeaderByHeaderId(this.ttQspiStockRecHeaderId).then(res => {
        this.detailForm = res.data
      });
    },
    getTableInfo() {
      StockRecoveryApi.getItemsByHeaderId(this.ttQspiStockRecHeaderId).then(res => {
        this.tableData1 = res.data
        this.$refs.plxTable1.reloadData(res.data)
      });
    },
    onDownload(row, index) {
      StockRecoveryApi.downloadFileByFullPath({
        fullPath: row.fullPath,
        documentName: row.fileName
      }).then((res) => {
        console.log('res', res);
        fileService.respToFile(res, row.fileName);
      })
    },
    getAttachmentsLists() {
      StockRecoveryApi.getAttachmentsByHeaderId(this.ttQspiStockRecHeaderId).then(res => {
        this.tableData2 = res.data
      });
    },
    getOperateLogs() {
      StockRecoveryApi.getOperateLogsByHeaderId(this.ttQspiStockRecHeaderId).then(res => {
        this.tableData3 = res.data
      });
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style>
</style>